/*
 * Lalume "Load More" for collection + search result pages.
 * Shopify's own numbered pagination stays untouched (real ?page=N links, server rendered). This script only adds:
 *   "Showing X of Y"  (above the numbers)   and   a real <button> "Load More"  (below the numbers).
 * Load More fetches the next Shopify page as the same section render the theme's AJAX filter/sort uses (?page=N&section_id=...),
 * appends only that page's product cards to the existing grid (deduped), and moves an internal next-page pointer. The pointer is
 * the href of the fetched page's own "next" link, so the complete query string (q, filter.*, sort_by ...) is kept and only `page`
 * changes. Nothing loads automatically: no scroll / IntersectionObserver trigger. No history entries are created.
 * Without JS, none of this exists and the page is the plain numbered pagination.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-section-type="collection-template"],[data-section-type="search-template"]');
  if (!root || !window.fetch || !window.DOMParser) return;
  if (window.Shopify && window.Shopify.designMode) return; // theme editor: numbered pagination only
  var listing = root.querySelector('.collection-listing');
  var prow = root.querySelector('.pagination-row');
  if (!listing || !prow) return;

  var SECTION_ID = root.getAttribute('data-filter-section-id') || root.getAttribute('data-section-id');
  var MAX_RESTORE = 12; // most pages re-fetched when returning from a product page
  var LABEL = 'Load More';

  // ---- UI (siblings of the pagination row, so the theme's AJAX swap of the row's contents never removes them) -----------------
  var countEl = document.createElement('div');
  countEl.className = 'lal-lm__count';
  countEl.setAttribute('role', 'status');
  countEl.setAttribute('aria-live', 'polite');
  countEl.setAttribute('tabindex', '-1');
  var wrap = document.createElement('div');
  wrap.className = 'lal-lm container';
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'lal-lm__btn';
  btn.textContent = LABEL;
  var msg = document.createElement('div');
  msg.className = 'lal-lm__msg';
  msg.setAttribute('role', 'status');
  wrap.appendChild(btn);
  wrap.appendChild(msg);
  prow.parentNode.insertBefore(countEl, prow);
  prow.parentNode.insertBefore(wrap, prow.nextSibling);

  var st = { grid: null, seen: {}, next: '', busy: false, gen: 0, ctrl: null, pages: 0, restoring: false, total: 0, offset: 0, hasMeta: false, extra: 0 };

  function grid() { return listing.querySelector('.product-list'); }
  // A card's identity: its product id, or product id + metal for the intentionally doubled Letter-collection cards (data-card-key).
  function cardKey(c) { return c.getAttribute('data-card-key') || c.getAttribute('data-product-id'); }
  function nextUrl(scope) { var a = scope.querySelector('a.pagination__next'); return a ? a.getAttribute('href') : ''; }
  function storeKey() { return 'lalLm:' + location.pathname + location.search; }

  // Distinct products on screen (a doubled Letter card is still one product).
  function rendered() {
    if (!st.grid) return 0;
    if (st.extra > 0) return st.grid.children.length; // Birthstone collections: the virtual January/July cards are real cards on screen (data-extra = how many extra cards the collection has)
    var u = {}, n = 0, i = 0;
    Array.prototype.forEach.call(st.grid.children, function (c) {
      var id = c.getAttribute('data-product-id') || ('#' + (i++));
      if (!u[id]) { u[id] = 1; n++; }
    });
    return n;
  }

  function render() {
    var show = st.hasMeta && st.total > 0;
    countEl.hidden = !show;
    wrap.hidden = !show || !st.next;
    if (!show) return;
    var n = rendered(), last = Math.min(st.offset + n, st.total + st.extra), tot = st.total + st.extra;
    if (st.extra > 0 && st.offset > 0) { countEl.textContent = 'Showing ' + n + ' of ' + tot; btn.setAttribute('aria-disabled', st.busy || st.restoring ? 'true' : 'false'); btn.classList.toggle('is-loading', st.busy || st.restoring); btn.textContent = st.busy || st.restoring ? 'Loading…' : LABEL; return; } // landed on ?page=N: card offset unknown, so no range claim
    // Page 1 start: "Showing 96 of 738". Landed on ?page=N: honest range, products before it are NOT on screen.
    countEl.textContent = st.offset > 0 ? 'Showing ' + (st.offset + 1) + '–' + last + ' of ' + tot : 'Showing ' + last + ' of ' + tot;
    btn.setAttribute('aria-disabled', st.busy || st.restoring ? 'true' : 'false');
    btn.classList.toggle('is-loading', st.busy || st.restoring);
    btn.textContent = st.busy || st.restoring ? 'Loading…' : LABEL;
  }

  // Rebuilds everything from the page as it is now (first load, and after the theme's AJAX filter / sort swap).
  function reset() {
    st.gen++;
    if (st.ctrl) { try { st.ctrl.abort(); } catch (e) {} st.ctrl = null; }
    st.busy = false; st.restoring = false; st.pages = 0;
    msg.textContent = '';
    st.grid = grid();
    st.seen = {};
    if (st.grid) Array.prototype.forEach.call(st.grid.children, function (c) { var id = cardKey(c); if (id) st.seen[id] = 1; });
    var meta = prow.querySelector('.lal-pg-meta');
    st.hasMeta = !!(meta && st.grid);
    st.total = meta ? parseInt(meta.getAttribute('data-total'), 10) || 0 : 0;
    st.offset = meta ? parseInt(meta.getAttribute('data-offset'), 10) || 0 : 0;
    st.extra = meta ? parseInt(meta.getAttribute('data-extra'), 10) || 0 : 0;
    st.next = st.hasMeta ? nextUrl(prow) : '';
    render();
  }

  function afterAppend(fresh) {
    var T = window.theme;
    if (!T) return;
    try {
      // same re-init the theme runs after its own AJAX swap (unload first, so handlers are never bound twice)
      var $ = T.jQuery || window.jQuery;
      if (T.ProductBlockManager && $) {
        var $c = $(root);
        T.ProductBlockManager.unloadImages($c);
        T.ProductBlockManager.loadImages($c);
      }
      if (T.flagOneLineTitles) fresh.forEach(function (c) { T.flagOneLineTitles(c); });
      if (T.initAnimateOnScroll) T.initAnimateOnScroll();
    } catch (e) {}
  }

  // Resolves true on success, false on failure/abort. The next-page pointer only moves on success.
  function load() {
    if (st.busy || !st.next || !st.grid) return Promise.resolve(false);
    var gen = st.gen, url = st.next;
    st.busy = true; msg.textContent = ''; render();
    var ctrl = st.ctrl = window.AbortController ? new AbortController() : null;
    var req = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(SECTION_ID);
    return fetch(req, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (text) {
        if (gen !== st.gen) return false; // a filter / sort change superseded this request
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var l = doc.querySelector('.collection-listing'), np = doc.querySelector('.pagination-row');
        var g = l && l.querySelector('.product-list');
        if (!g || !np) throw new Error('unexpected response');
        var out = '';
        Array.prototype.forEach.call(g.children, function (c) {
          var id = cardKey(c);
          if (id && st.seen[id]) return; // never twice
          if (id) st.seen[id] = 1;
          out += c.outerHTML; // as markup, so the live document parses it (<noscript> stays inert, no scripts run)
        });
        var before = st.grid.children.length;
        if (out) st.grid.insertAdjacentHTML('beforeend', out);
        var fresh = Array.prototype.slice.call(st.grid.children, before);
        st.next = nextUrl(np); // the fetched page's own next link: same query string, page + 1; empty on the last page
        st.busy = false; st.ctrl = null; st.pages++;
        var hadFocus = document.activeElement === btn;
        afterAppend(fresh);
        render();
        if (hadFocus && wrap.hidden) countEl.focus({ preventScroll: true }); // button went away at the end: keep focus on the page
        save();
        return true;
      })
      .catch(function () {
        if (gen !== st.gen) return false; // aborted or superseded: the new state owns the flags now
        st.busy = false; st.ctrl = null; // pointer NOT advanced, nothing appended: a click retries the same page
        msg.textContent = 'Sorry, we could not load more products. Please try again.';
        render();
        return false;
      });
  }

  btn.addEventListener('click', function () {
    if (st.busy || st.restoring) return; // aria-disabled (not disabled) keeps keyboard focus on the button while loading
    load();
  });

  // ---- Back / forward from a product page: same pages loaded again, same scroll position (sessionStorage, same tab only) ------
  function savedState() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (!nav || nav.type !== 'back_forward') { sessionStorage.removeItem(storeKey()); return null; }
      return JSON.parse(sessionStorage.getItem(storeKey()));
    } catch (e) { return null; }
  }
  function restore(s) {
    var g0 = st.gen, target = Math.min(s.p || 0, MAX_RESTORE), prevMode = null;
    try { prevMode = history.scrollRestoration; history.scrollRestoration = 'manual'; } catch (e) {}
    st.restoring = true; render();
    function settle() {
      if (g0 !== st.gen) return;
      st.restoring = false; render();
      try { history.scrollRestoration = prevMode || 'auto'; } catch (e) {}
      window.scrollTo({ top: s.y || 0, left: 0, behavior: 'instant' });
    }
    (function step() {
      if (g0 !== st.gen) return;
      if (st.pages >= target || !st.next) return settle();
      st.restoring = false; // load() only checks busy
      load().then(function (ok) { st.restoring = true; if (ok) step(); else settle(); });
    })();
  }
  // Saved after each load and while scrolling (not only on pagehide: Safari does not reliably persist writes made during unload).
  function save() {
    if (st.restoring) return;
    try {
      if (st.pages > 0) sessionStorage.setItem(storeKey(), JSON.stringify({ p: st.pages, y: Math.round(window.scrollY) }));
      else sessionStorage.removeItem(storeKey());
    } catch (e) {}
  }
  var saveTimer = 0;
  window.addEventListener('scroll', function () {
    if (saveTimer) return;
    saveTimer = window.setTimeout(function () { saveTimer = 0; save(); }, 150);
  }, { passive: true });
  window.addEventListener('pagehide', save);

  // Filter / sort replace the grid element: start again from the new first page (the row's contents are swapped by the theme too).
  if (window.MutationObserver) {
    new MutationObserver(function () { if (grid() !== st.grid) reset(); }).observe(listing, { childList: true });
  }

  var s0 = savedState();
  reset();
  if (s0 && s0.p > 0 && st.next) restore(s0);
})();
